export enum CustomerLoyaltyErrorCodes {
  CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
  NO_POINTS = 'NO_POINTS'
}
